import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from '../services/auth.service';
import {Observable} from 'rxjs';
import {Globals} from '../global/globals';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private globals: Globals) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authUri = this.globals.backendUri + '/authentication';
    const regUri = this.globals.backendUri + '/register';
    const resetUrl = this.globals.backendUri + '/resetPassword';
    const updatePsw = this.globals.backendUri + '/resetPassword' + '/updatePassword';

    // Do not intercept authentication requests
    if (req.url === authUri) {
      return next.handle(req);
    }
    if (req.url === regUri) {
      return next.handle(req);
    }
    if (req.url === resetUrl) {
      return next.handle(req);
    }
    if (req.url === updatePsw) {
      return next.handle(req);
    }

    const authReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + this.authService.getToken())
    });

    return next.handle(authReq);
  }
}
